<template>
    <div data-app>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text
                    >Silmek istediğiniz kayıt kalıcı olarak silinecektir. Bu
                    kaydı silmek istediğinize emin misiniz?</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog = false">
                        Hayır
                    </v-btn>
                    <v-btn class="text-success" text @click="deletePermission">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="col-md-12">   
            <KTCard v-bind:title="title">
                <template v-slot:body>
                    <form ref="form" id="form" novalidate="novalidate" lazy-validation class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                        <div class="m-portlet__body">
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">İzin Adı:</label>
                                <div class="col-lg-6">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="permission.name">
                                    <div v-if="errors.name" :errors="errors">
                                        <b-badge v-for="error in errors.name" class="mr-1" :key="error.name" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Arayüz:</label>
                                <div class="col-lg-6">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="permission.guard_name">
                                    <div v-if="errors.guard_name" :errors="errors">
                                        <b-badge v-for="error in errors.guard_name" class="mr-1" :key="error.guard_name" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Kullanıcı Grupları:</label>
                                <div class="col-lg-6">
                                    <multiselect 
                                        v-model="permission.roles"
                                        :class="{view: !isEditing}" 
                                        :disabled="!isEditing" 
                                        :options="roles" 
                                        :multiple="true" 
                                        :close-on-select="false" 
                                        :clear-on-select="true" 
                                        :preserve-search="false" 
                                        :preselect-first="false" 
                                        :internal-search="false" 
                                        :hide-selected="true"
                                        label="name" 
                                        track-by="name"
                                        @search-change="findByRoleName"
                                    >
                                    </multiselect>
                                    <div v-if="errors.code" :errors="errors">
                                        <b-badge v-for="error in errors.code" class="mr-1" :key="error.code" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Kullanıcılar:</label>
                                <div class="col-lg-6">
                                    <multiselect 
                                        v-model="permission.users"
                                        :class="{view: !isEditing}" 
                                        :disabled="!isEditing" 
                                        :options="users" 
                                        :multiple="true" 
                                        :close-on-select="false" 
                                        :clear-on-select="true" 
                                        :preserve-search="false" 
                                        :preselect-first="false" 
                                        :internal-search="false" 
                                        :hide-selected="true"
                                        label="name" 
                                        track-by="name"
                                        @search-change="findByUserName"
                                    >
                                    </multiselect>
                                    <div v-if="errors.code" :errors="errors">
                                        <b-badge v-for="error in errors.code" class="mr-1" :key="error.code" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <template v-if="timeStamps">
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Ekleyen:</label>
                                    <div class="col-lg-6">
                                        {{ permission.user_created_name }}
                                    </div>
                                </div>
                                
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Ekleme Tarihi:</label>
                                    <div class="col-lg-6">
                                        <span>{{ permission.created_at | formatDateTime }}</span>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Güncelleyen:</label>
                                    <div class="col-lg-6">
                                        {{ permission.user_updated_name }}
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Güncelleme Tarihi:</label>
                                    <div class="col-lg-6">
                                        <span>{{ permission.updated_at | formatDateTime }}</span>
                                    </div>
                                </div>

                        </template>
                          
                        </div>
                        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                            <div class="m-form__actions m-form__actions--solid">
                                <div class="row">
                                    <div class="col-lg-2"></div>
                                    <div class="col-lg-6">
                                        <!-- EKLEME BUTONLARI -->
                                        <template v-if="addButtons">
                                            <b-button
                                                v-if="hasPermission('permissions.create')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="savePermissionAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Kaydet ve Geri Dön
                                            </b-button>
                                            
                                            <b-button
                                                v-if="hasPermission('permissions.create')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="savePermissionAndAddNew()"
                                            >
                                            <i class="la la-save"></i>
                                                Kaydet ve Yeni Ekle
                                            </b-button>
                                        </template>

                                        <!-- GÜNCELLEME BUTONLARI -->
                                        <template v-if="editButtons">  
                                            <b-button
                                                v-if="hasPermission('permissions.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="updatePermissionAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Güncelle ve Geri Dön
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('permissions.update')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="updatePermission()"
                                            >
                                            <i class="la la-save"></i>
                                                Güncelle
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('permissions.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            
                                            
                                        </template>

                                        <!-- GÖRÜNTÜLEME BUTONLARI -->
                                        <template v-if="viewButtons">
                                            <b-button
                                                v-if="hasPermission('permissions.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('permissions.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="changeFormToEditing()"
                                            >
                                            <i class="la la-edit"></i>
                                                Güncellemeyi Aktif Et
                                            </b-button>
 
                                        </template>   
                                        <template>
                                            <b-button 
                                                size="sm" 
                                                @click="$router.go(-1)">
                                                <i class="la la-undo"></i>
                                                İptal
                                            </b-button> 
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>
            </KTCard>
        </div>
        <div class="text-center">
            <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
                v-if="loading"
            ></b-spinner>
        </div>
    </div>
</template>

<script>

import KTCard from "@/view/content/Card.vue";
import { mapGetters} from 'vuex';
import { mapState} from 'vuex';
import { GET_PERMISSION_DATA } from "@/core/services/store/permissions.module";
import { CREATE_PERMISSION } from "@/core/services/store/permissions.module";
import { UPDATE_PERMISSION } from "@/core/services/store/permissions.module";
import { DELETE_PERMISSION } from "@/core/services/store/permissions.module";
import { FIND_BY_ROLE_NAME } from "@/core/services/store/roles.module";
import { FIND_BY_USER_NAME } from "@/core/services/store/users.module";
import Multiselect from 'vue-multiselect'
//import Echo from 'laravel-echo';

export default {
    name: "permissions-form",

    data() {
        return {
            dialog: false,
            permission:{
                user_created_name: "",
                user_updated_name: ""
            },
            formType: "",
            title: "",
            addButtons: false,
            editButtons: false,
            viewButtons: false,
            timeStamps: false,
            isEditing: true,
            permissions: {},
            roles: [],
            users: [],
            timer: null,
            
        };
    },
   
    methods: {
        savePermissionAndGoBack() {
            const data = this.permission;
            const goBack = true;
            this.$store.dispatch(CREATE_PERMISSION, {data, goBack})
            this.$store.dispatch('getUserMenu');
        },

        savePermissionAndAddNew() {
            const data =  this.permission;
            const goBack = false;
            this.$store.dispatch(CREATE_PERMISSION, {data, goBack})
            this.$store.dispatch('getUserMenu');
        },

        updatePermissionAndGoBack() {
            const data = this.permission;
            const goBack = true;
            this.$store.dispatch(UPDATE_PERMISSION, { data, goBack })
            this.$store.dispatch('getUserMenu');
        },

        updatePermission() {
            const data = this.permission;
            const goBack = false;
            this.$store.dispatch(UPDATE_PERMISSION, { data, goBack })
            this.$store.dispatch('getUserMenu');
        },

        deletePermission() {
            var itemToDelete = this.permission.id;
            this.$store.dispatch(DELETE_PERMISSION, { itemToDelete })
            .then(() => { 
                this.$store.dispatch('getUserMenu');
                this.$router.go(-1);
                this.dialog = false;
            })
        },

        changeFormToAdding(){
            this.title = "İzin: Yeni Kayıt Formu"
            
            this.addButtons = true;
            this.editButtons = false;
            this.viewButtons = false;
            this.timeStamps = false;
            this.isEditing = true;
        },

        changeFormToEditing(){
            this.title = "İzin: Güncelleme Formu"
            this.addButtons = false;
            this.editButtons = true;
            this.viewButtons = false;
            this.timeStamps = true;
            this.isEditing = true;
        },

        changeFormToViewing(){
            this.title = "İzin: Detaylar"
            this.addButtons = false;
            this.editButtons = false;
            this.viewButtons = true;
            this.timeStamps = true;
            this.isEditing = false;
        },

        hasPermission(permission) {
            return this.currentUserMenu.permissions.some(function(el) {
                return el.name === permission;
            }); 
        },

        findByRoleName (searchText) {
            var x = 1;
            
            if((searchText.length)>2){
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch(FIND_BY_ROLE_NAME, {searchText, x})
                    .then((response) => {
                        this.roles = response.data;
                    })
                }, 500);
            }

            
        },

        findByUserName (searchText) {
            var x = 1;
            
            if((searchText.length)>2){
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch(FIND_BY_USER_NAME, {searchText, x})
                    .then((response) => {
                        this.users = response.data;
                    })
                }, 500);
            }

        },
    },


    components: {
        KTCard,
        Multiselect
    },

    created() {
        this.isEditing = !this.isEditing;
        this.formType = this.$route.params.formType;
        this.$store.dispatch('getUserMenu');
        this.$store.dispatch('createPermissionForm');
        if (this.formType != "add") {
            var id = this.$route.params.id;
            this.$store.dispatch(GET_PERMISSION_DATA, { id })
            .then(( response ) => {
                this.permission = response.data;
                this.roles = response.data.roles;
                this.permission.user_created_name = response.data.user_created_name[0].name;
                this.permission.user_updated_name = response.data.user_updated_name[0].name;
            })
        }

    },

    mounted(){
        
        if(this.formType === "add"){
            this.changeFormToAdding();
        }
        if(this.formType === "edit"){
            this.changeFormToEditing();
        }
        if(this.formType === "view"){
            this.changeFormToViewing();
        }
    },

    computed: {
        ...mapGetters(["currentUserMenu"]),

        ...mapState({
            loading: state => state.permissions.loading,
            row: state => state.permissions.row,
            errors: state => state.permissions.errors,
            isDisabled: state => state.permissions.isDisabled,
            //user: state => state.users.user_data
        })
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.view {
    border-color: transparent;
    background-color: initial;
    color: initial
}
</style>
